import { BlockPasswordChangeDialogComponent } from '../dialogs/block-password-change-dialog/block-password-change-dialog.component';

export { BlockPasswordChangeDialogComponent };
